import type { ReactNode } from "react";

type InputOutputPanelProps = {
  input: ReactNode;
  output: ReactNode;
  inputTitle?: string;
  outputTitle?: string;
  inputActions?: ReactNode;
  outputActions?: ReactNode;
};

export function InputOutputPanel({
  input,
  output,
  inputTitle = "Input",
  outputTitle = "Output",
  inputActions,
  outputActions,
}: InputOutputPanelProps) {
  return (
    <div className="grid gap-4 xl:grid-cols-2">
      <section className="min-w-0 rounded-lg border border-zinc-200 bg-white">
        <div className="flex min-h-12 items-center justify-between gap-3 border-b border-zinc-200 px-4 py-3">
          <h2 className="text-sm font-semibold text-zinc-950">{inputTitle}</h2>
          <div className="flex flex-wrap items-center gap-2">{inputActions}</div>
        </div>
        <div className="p-4">{input}</div>
      </section>
      <section className="min-w-0 rounded-lg border border-zinc-200 bg-white">
        <div className="flex min-h-12 items-center justify-between gap-3 border-b border-zinc-200 px-4 py-3">
          <h2 className="text-sm font-semibold text-zinc-950">{outputTitle}</h2>
          <div className="flex flex-wrap items-center gap-2">{outputActions}</div>
        </div>
        <div className="p-4">{output}</div>
      </section>
    </div>
  );
}
